
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Coins, MapPin, Phone, Truck, Star, Building } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const AchatMetauxValDOise = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Achat Métaux Val-d'Oise (95) - Cergy, Argenteuil | Groupe Fabre"
        description="Rachat de métaux et ferrailles en Val-d'Oise : Cergy, Argenteuil, Sarcelles. Solutions franciliennes, proximité Paris."
        canonical="/nos-services/achat-metaux/val-doise"
        keywords="achat métaux Val-d'Oise, rachat ferraille Cergy, achat cuivre Argenteuil, ferrailleur 95"
        localBusiness={{ city: "Cergy", region: "Val-d'Oise", postalCode: "95000", serviceType: "Achat de métaux" }}
      />
      <Navbar />
      
      <main className="flex-1 mt-16">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <div className="flex items-center mb-4">
                <Building className="h-12 w-12 mr-4" />
                <div>
                  <h1 className="text-4xl md:text-5xl font-bold">Achat Métaux Val-d'Oise (95)</h1>
                  <p className="text-xl mt-2 opacity-90">Francilie - Solutions urbaines</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-3xl font-bold text-fabre-gray mb-6">
                  Rachat de métaux en Val-d'Oise - Proximité parisienne
                </h2>
                <p className="text-gray-600 mb-6">
                  Le <strong>Val-d'Oise</strong> bénéficie de la proximité parisienne tout en gardant 
                  son caractère mixte urbain-rural. <strong>Groupe Fabre Environnement</strong> 
                  étend son expertise jusqu'en région parisienne pour proposer des 
                  <strong>solutions franciliennes</strong> adaptées.
                </p>
                
                <h3 className="text-xl font-bold text-fabre-gray mb-4">Zones de couverture francilienne</h3>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-indigo-500 text-white mr-3">•</span>
                    <span><strong>Cergy :</strong> Ville nouvelle et technopôle</span>
                  </li>
                  <li className="flex items-start">
                    <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-indigo-500 text-white mr-3">•</span>
                    <span><strong>Argenteuil :</strong> Zone industrielle historique</span>
                  </li>
                  <li className="flex items-start">
                    <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-indigo-500 text-white mr-3">•</span>
                    <span><strong>Sarcelles :</strong> Secteur résidentiel dense</span>
                  </li>
                  <li className="flex items-start">
                    <span className="inline-flex items-center justify-center h-6 w-6 rounded-full bg-indigo-500 text-white mr-3">•</span>
                    <span><strong>Pontoise :</strong> Centre administratif</span>
                  </li>
                </ul>

                <div className="bg-indigo-50 border border-indigo-200 p-6 rounded-lg">
                  <h4 className="font-bold text-indigo-800 mb-3">🏙️ Expertise francilienne</h4>
                  <ul className="text-indigo-700 text-sm space-y-2">
                    <li>• Adaptation aux contraintes urbaines franciliennes</li>
                    <li>• Logistique optimisée région parisienne</li>
                    <li>• Créneaux horaires adaptés à la densité</li>
                    <li>• Prix compétitifs marché parisien</li>
                  </ul>
                </div>
              </div>

              <div className="bg-gray-50 p-8 rounded-lg">
                <h3 className="text-2xl font-bold text-fabre-gray mb-6">Service Val-d'Oise</h3>
                <p className="text-gray-600 mb-6">
                  Notre extension en région parisienne nous permet de proposer 
                  notre expertise méridionale au marché francilien.
                </p>
                
                <div className="space-y-4 mb-6">
                  <div className="flex items-center">
                    <Building className="h-5 w-5 text-indigo-500 mr-3" />
                    <span>Solutions urbaines</span>
                  </div>
                  <div className="flex items-center">
                    <Coins className="h-5 w-5 text-indigo-500 mr-3" />
                    <span>Prix franciliens</span>
                  </div>
                  <div className="flex items-center">
                    <Star className="h-5 w-5 text-indigo-500 mr-3" />
                    <span>Expertise Sud-Nord</span>
                  </div>
                </div>

                <Link to="/contact" className="block">
                  <button className="w-full px-6 py-3 bg-indigo-500 text-white rounded-md font-medium hover:bg-indigo-600 transition-colors">
                    Demander prix Val-d'Oise
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Spécificités Val-d'Oise */}
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-2xl font-bold text-fabre-gray mb-8 text-center">
              Spécialisations Val-d'Oise
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="font-bold text-gray-700 mb-3">Nouvelles Technologies</h3>
                <p className="text-sm text-gray-600 mb-3">
                  High-tech, équipements informatiques
                </p>
                <div className="text-purple-600 font-medium">Expertise tech</div>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="font-bold text-gray-700 mb-3">BTP Francilien</h3>
                <p className="text-sm text-gray-600 mb-3">
                  Chantiers urbains, rénovations parisiennes
                </p>
                <div className="text-orange-600 font-medium">Logistique urbaine</div>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="font-bold text-gray-700 mb-3">Aéronautique</h3>
                <p className="text-sm text-gray-600 mb-3">
                  Proximité Roissy, équipements aéroportuaires
                </p>
                <div className="text-blue-600 font-medium">Prix spécialisés</div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default AchatMetauxValDOise;
